const C = {
  name: "SecurityTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13Z" fill="currentColor"/>
<path d="M15 7V8.17071C16.1652 8.58254 17 9.69378 17 11V13C17 14.6569 15.6569 16 14 16H10C8.34315 16 7 14.6569 7 13V11C7 9.69378 7.83481 8.58254 9 8.17071V7C9 6.20435 9.31607 5.44129 9.87868 4.87868C10.4413 4.31607 11.2044 4 12 4C12.7956 4 13.5587 4.31607 14.1213 4.87868C14.6839 5.44129 15 6.20435 15 7ZM9 11V13C9 13.5523 9.44771 14 10 14H14C14.5523 14 15 13.5523 15 13V11C15 10.4477 14.5523 10 14 10H10C9.44771 10 9 10.4477 9 11ZM13 7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6C11.7348 6 11.4804 6.10536 11.2929 6.29289C11.1054 6.48043 11 6.73478 11 7V8H13V7Z" fill="currentColor"/>
<path d="M1 3C1 1.34315 2.34315 0 4 0H20C21.6569 0 23 1.34315 23 3V17C23 18.6569 21.6569 20 20 20H4C2.34315 20 1 18.6569 1 17V3ZM4 2C3.44772 2 3 2.44772 3 3V17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V3C21 2.44772 20.5523 2 20 2H4Z" fill="currentColor"/>
<path d="M16 22V24H8V22H16Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as SecurityTeam
};
